import { render } from "./product_category.vue?vue&type=template&id=e2ae1c68"
import script from "./product_category.vue?vue&type=script&lang=js"
export * from "./product_category.vue?vue&type=script&lang=js"

import "./product_category.vue?vue&type=style&index=0&id=e2ae1c68&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__